export default __webpack_public_path__ + "static/media/loksabhabg.4b84492b.jpg";